import { getUsuario } from "../auth"
import API from "./index"

class ManuaisRoteirosAtosService {
  constructor() {
    this.path = `api/manuaisroteirosatos`
  }

  async findAll({ page = 0, size = 10, descricao = "", situacao = null }) {
    const params = {
      page: page - 1 < 0 ? 0 : page - 1,
      size: size,
    }

    if (descricao !== "") {
      params.descricao = descricao
    }
    if (situacao !== null) {
      params.situacao = situacao
    }
    return await API.get(this.path, { params })
  }
  async find() {
    return await API.get(`${this.path}`)
  }
  async findById(id) {
    return await API.get(`${this.path}/${id}`)
  }

  async save(record) {
    let usuario = getUsuario().nome
    const updatedRecord = { ...record, usuario }
    if (updatedRecord.id) {
      return await API.put(
        `${this.path}/${updatedRecord.id}`,
        updatedRecord
      ).then(({ ...args }) => ({ created: false, ...args }))
    }

    return API.post(this.path, updatedRecord).then(({ ...args }) => ({
      created: true,
      ...args,
    }))
  }

  async alteraSituacao({ id, situacao }) {
    return await API.put(`${this.path}/${id}/situacao`, { situacao }).then(
      ({ ...args }) => ({ created: false, ...args })
    )
  }

  async remove(id) {
    if (!id) {
      throw new Error("ID cannot be null")
    }
    return await API.delete(`${this.path}/${id}`)
  }
}
export default ManuaisRoteirosAtosService
